export const getMonthName = (monthIndex) => {
    const monthNames = ["January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
    ];
    return monthNames[monthIndex];
}

export const getCurrentMonthName = (epoch = Date.now()) => {
    const d = new Date(epoch);
    return getMonthName(d.getMonth());
}

export const getCurrentYear = (epoch = Date.now()) => {
    const d = new Date(epoch);
    return d.getFullYear();
}

export const formatDateToFancyString = (epoch = Date.now()) => 
    new Date(epoch).toLocaleDateString('en-us', { year:"numeric", month:"short", day:"numeric"}) 

export const formatDateTimeToFancyString = (epoch = Date.now()) => 
    new Date(epoch).toLocaleDateString('en-us', { year:"numeric", month:"short", day:"numeric", hour: "numeric", minute: "numeric"}) 
    
export const formatSecondsToPrettyMSTime = (time) => {
    if (time < 0 || time === undefined) return undefined;
    const minutes = Math.floor(time / 60)
    const seconds = Math.floor(time % 60)
    return `${minutes < 10 ? '0' + String(minutes) : String(minutes)}m ${seconds < 10 ? '0' + String(seconds) : String(seconds)}s`
}

export const formatSecondsToPrettyHMTime = (seconds) => {
    const time = seconds / 60
    const hours = (time / 60);
    const rhours = Math.floor(hours);
    const minutes = (hours - rhours) * 60;
    const rminutes = Math.round(minutes);
    return rhours + "h " + rminutes + "m";
}

export const getMonthDateRange = (year, month) => {
    // Adjust month to 0-based index for JavaScript Date
    const startDate = new Date(year, month - 1, 1);
    const endDate = new Date(year, month, 0); // Last day of the month

    // Format dates as YYYY-MM-DD
    const formatDate = (date) => date.toISOString().split('T')[0];

    return {
        start: formatDate(startDate),
        end: formatDate(endDate),
    };
}

export const calculateStartDate = (year, month, date, pastDaysCount) => {
    const inputDate = new Date(year, month - 1, date);
    inputDate.setDate(inputDate.getDate() - pastDaysCount);
    return formatDateToYYYYMMDD(inputDate);
}

export const formatDateToYYYYMMDD = (date) => date.toISOString().split('T')[0];

export const formatYYYYMMToHumanString = (yyyymm) => {
    const [year, month] = yyyymm.split('-');
    const monthName = getMonthName(parseInt(month, 10)-1);
    return `${monthName} ${year}`;
}

export const convertISOTimetToEpoch = (isoStr) => {
    return new Date(isoStr).getTime();
}

export const formatClockifyTimeInterval = (entry) => {
    const time_interval = entry.timeInterval;
    const start = new Date(time_interval.start)

    let formattedEnd;
    let formattedDuration;
    let duration_in_seconds;
    if (time_interval.end && time_interval.end !== null) {
        const end = new Date(time_interval.end)
        formattedEnd = formatDateTimeToFancyString(end.getTime())
        formattedDuration = formatSecondsToPrettyHMTime((end - start) / 1000);
        duration_in_seconds = (end - start) / 1000;
    } else {
        formattedEnd = '---'
        formattedDuration = formatSecondsToPrettyHMTime((Date.now() - start) / 1000);
        duration_in_seconds = (Date.now() - start) / 1000;
    }

    return {
        id: entry.id,
        description: entry.description,
        time_formatted: {
            start: formatDateTimeToFancyString(start.getTime()),
            end: formattedEnd,
            duration: formattedDuration
        },
        duration_in_seconds
    }
}

export const timeAgo = (epoch) => {
    const now = Date.now();
    const diffMs = now - Number(epoch);
  
    const minutes = Math.floor(diffMs / (1000 * 60));
    const hours = Math.floor(diffMs / (1000 * 60 * 60));
    const days = Math.floor(diffMs / (1000 * 60 * 60 * 24));
  
    if (minutes < 1) return "Opened just now";
  
    if (minutes < 60) {
      return `Opened ${minutes} minute${minutes === 1 ? "" : "s"} ago`;
    }
  
    if (hours < 24) {
      return `Opened ${hours} hour${hours === 1 ? "" : "s"} ago`;
    }
  
    return `Opened ${days} day${days === 1 ? "" : "s"} ago`;
  }